import {Box, Toolbar, Typography} from '@mui/material';
import MuiAppBar from '@mui/material/AppBar';
import {Link} from 'react-router-dom';
import {Color} from '../../../common/theme';

export const EditFormHeader = () => {
    // const handleLogout = () => {};
    return (
        <MuiAppBar position='fixed' sx={{backgroundColor: Color.WHITE, zIndex: (theme) => theme.zIndex.drawer + 1}}>
            <Toolbar disableGutters sx={{paddingLeft: 2, paddingRight: 2}}>
                <Box sx={{flexGrow: 1, display: {md: 'flex'}}}>
                    <Link to='/'>
                        <div className='flex items-center'>
                            <Typography
                                style={{
                                    fontFamily: 'Poppins',
                                    fontWeight: 700,
                                    color: 'black',
                                }}
                                variant='h6'
                                noWrap
                                component='div'>
                                Dashboard
                            </Typography>
                        </div>
                    </Link>
                </Box>
            </Toolbar>
        </MuiAppBar>
    );
};
